"use client";

import { usePathname } from "next/navigation";
import AdSenseSidebar from "./AdSenseSidebar";
import { useEffectivePass } from "@/hooks/useEffectivePass";
import { isMockExamShellPage, isSidebarAdHidden } from "@/lib/route-layout";

interface AdSenseWrapperProps {
  adSlot?: string;
}

export default function AdSenseWrapper({ adSlot }: AdSenseWrapperProps) {
  const pathname = usePathname();
  const { isAdFree, isLoaded, isSignedIn } = useEffectivePass();
  const isMockExamAdPage = isMockExamShellPage(pathname);

  // Clerk 로드 전에는 렌더링하지 않음 (starter+ 사용자 광고 깜빡임 방지)
  if (!isLoaded) {
    return null;
  }

  // starter 이상 이용권 사용자는 광고 미노출
  if (isAdFree) {
    return null;
  }

  // mock/final mock 시험 페이지는 비로그인 사용자에게 사이드바 AdSense 를 노출하지 않는다.
  if (isMockExamAdPage && !isSignedIn) {
    return null;
  }

  // wide-layout 페이지·결제·로그인·관리자 등 사이드바 광고 부적절한 경로 차단.
  // 정책은 src/lib/route-layout.ts 의 isSidebarAdHidden 단일 진입점에서 관리.
  if (isSidebarAdHidden(pathname)) {
    return null;
  }

  return <AdSenseSidebar adSlot={adSlot} />;
}
